module.exports = __webpack_public_path__ + "img/icon01.abb2b7f0.svg";